export const SERVICES = [
  {
    id: "app-development",
    title: "Application Development",
    tag: "BUILD",
    icon: "Terminal",
    short: "Native, web, and cross-platform applications engineered for scale.",
    description: "From concept to deployment, we design resilient product architectures using modern stacks (React, FastAPI, Kubernetes) with observability, security, and CI/CD baked in from day one.",
    capabilities: [
      "Web & mobile product engineering",
      "API-first architecture & micro-services",
      "DevSecOps, observability, SRE",
      "Cloud-native deployment (AWS / GCP / Azure)",
    ],
  },
  {
    id: "digital-transformation",
    title: "Business Digital Transformation",
    tag: "EVOLVE",
    icon: "Hexagon",
    short: "Re-engineer legacy operations into intelligent digital workflows.",
    description: "We modernize legacy systems, automate core processes, and install data platforms that turn operational signal into decision-grade intelligence across your organization.",
    capabilities: [
      "Legacy modernization & cloud migration",
      "Process automation (RPA + AI)",
      "Data platforms & analytics",
      "Change management & enablement",
    ],
  },
  {
    id: "agentic-ai",
    title: "Agentic AI",
    tag: "AUTONOMY",
    icon: "Cpu",
    short: "Deploy goal-driven AI agents that execute, adapt, and collaborate.",
    description: "We build production-grade agentic systems with tool use, memory, and human-in-the-loop safety — orchestrating LLMs to run real business workflows end to end.",
    capabilities: [
      "Custom agent orchestration frameworks",
      "RAG & private knowledge graphs",
      "Multi-agent systems & tool calling",
      "Safety, evaluation & observability",
    ],
  },
  {
    id: "iot",
    title: "Internet of Things",
    tag: "CONNECT",
    icon: "Network",
    short: "Edge-to-cloud telemetry for the physical world.",
    description: "Firmware, gateways, and cloud pipelines engineered for millions of devices — secure by design, with real-time analytics and OTA updates for fleets at scale.",
    capabilities: [
      "Embedded firmware & edge AI",
      "Industrial IoT & Digital Twins",
      "MQTT / LoRaWAN / 5G gateways",
      "Real-time telemetry dashboards",
    ],
  },
];

export const CASE_STUDIES = [
  {
    id: "cs-001",
    code: "AR-001",
    client: "Helix Manufacturing",
    sector: "Industrial IoT",
    title: "Predictive fleet intelligence across 14 plants",
    summary: "Deployed an edge-to-cloud IoT platform ingesting 2.4B telemetry events per day, cutting unplanned downtime by 38%.",
    impact: "38% downtime reduction",
    year: 2025,
  },
  {
    id: "cs-002",
    code: "AR-002",
    client: "Orbital Finance",
    sector: "Agentic AI",
    title: "Autonomous underwriting copilots",
    summary: "Built a multi-agent underwriting assistant that reviews 10K documents/day with human-in-the-loop escalation.",
    impact: "6x analyst throughput",
    year: 2025,
  },
  {
    id: "cs-003",
    code: "AR-003",
    client: "Meridian Health",
    sector: "Digital Transformation",
    title: "Legacy modernization for a national provider network",
    summary: "Migrated 42 monolithic systems to a cloud-native event-driven backbone with zero downtime cutover.",
    impact: "$11M annual savings",
    year: 2024,
  },
  {
    id: "cs-004",
    code: "AR-004",
    client: "Vanta Logistics",
    sector: "Application Development",
    title: "Real-time last-mile orchestration app",
    summary: "Shipped a React Native + FastAPI dispatch platform used by 18K drivers across 9 countries.",
    impact: "24% faster delivery SLA",
    year: 2024,
  },
];

export const CAREERS = [
  { id: "role-001", title: "Senior AI Engineer", location: "Pan India / Remote", type: "Full-time", team: "Agentic AI" },
  { id: "role-002", title: "Staff Full-Stack Engineer", location: "Remote (Global)", type: "Full-time", team: "Platform" },
  { id: "role-003", title: "Embedded Systems Engineer", location: "Pan India", type: "Full-time", team: "IoT" },
  { id: "role-004", title: "Product Designer", location: "Remote", type: "Full-time", team: "Design" },
  { id: "role-005", title: "Solutions Architect", location: "Dubai / Hybrid", type: "Full-time", team: "Transformation" },
];
